var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43012 0.942087C9.63415 1.14612 9.63415 1.47692 9.43012 1.68096L4.55383 6.55725C4.3498 6.76128 4.019 6.76128 3.81496 6.55725L1.02851 3.77079C0.82448 3.56676 0.82448 3.23596 1.02851 3.03193C1.23255 2.82789 1.56335 2.82789 1.76738 3.03193L4.1844 5.44894L8.69125 0.942087C8.89528 0.738054 9.22609 0.738054 9.43012 0.942087Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTick);
export default __webpack_public_path__ + "static/media/White_tick.c3718ce26f35f377ae99dd0d7d1c3e4c.svg";
export { ForwardRef as ReactComponent };